import { ClientLocationService } from "../Geo/ClientLocationService";

export class BaseService {
  //protected static BaseApiUrlDev = "https://localhost:7292";
  //protected static BaseApiUrl = process.env.REACT_APP_API_URL;

  protected static BaseApiUrl = (process.env.REACT_APP_API_URL || "") + "/api";

  public static SecretCryptoCode = "secretCode___3423424";
  public static UserLocalStorageKey = "usr_current";
  public static TokenLocalStorageKey = "zwpat0_1";

  public static post<T>(url: string, data?: {} | null): Promise<T> {
    return this.sendXhrWithFormData(url, "POST", data);
  }

  public static get<T>(url: string): Promise<T> {
    return this.sendXhrWithFormData(url, "GET");
  }

  public static put<T>(url: string, data?: {} | FormData | null): Promise<T> {
    return this.sendXhrWithFormData(url, "PUT", data);
  }

  public static delete<T>(url: string): Promise<T> {
    return this.sendXhrWithFormData(url, "DELETE");
  }

  private static sendXhrWithFormData<T>(url: string, method: "GET" | "POST" | "PUT" | "DELETE", data?: any | null): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.withCredentials = true;
      const isFormData = data instanceof FormData;

      if (!isFormData) {
        xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      }

      xhr.setRequestHeader("Authorization", `Bearer ${localStorage.getItem(BaseService.TokenLocalStorageKey)}`);

      const headers = ClientLocationService.getHeaders();

      if (headers["X-Client-Latitude"]) {
        xhr.setRequestHeader("X-Client-Latitude", headers["X-Client-Latitude"]);
      }

      if (headers["X-Client-Longitude"]) {
        xhr.setRequestHeader("X-Client-Longitude", headers["X-Client-Longitude"]);
      }

      xhr.onreadystatechange = () => {
        if (xhr.readyState !== XMLHttpRequest.DONE) return;

        const rawText = xhr.responseText?.trim() ?? "";

        let responseBody: any = null;

        try {
          if (rawText.length > 0) {
            responseBody = JSON.parse(rawText);
          }
        } catch {
          console.warn("Сервер вернул не JSON:", xhr.responseText);
        }

        if (xhr.status >= 200 && xhr.status < 300) {
          const result = responseBody && responseBody.value !== undefined ? responseBody.value : responseBody;
          resolve(result as T);
          return;
        }

        let errorMsg = `Ошибка сервера: ${xhr.status}`;

        if (typeof responseBody === "string" && responseBody.trim()) {
          errorMsg = responseBody.trim();
        } else if (responseBody?.error) {
          errorMsg = String(responseBody.error).trim();
        } else if (responseBody?.message) {
          errorMsg = String(responseBody.message).trim();
        } else if (responseBody?.value) {
          errorMsg = String(responseBody.value).trim();
        } else if (rawText) {
          errorMsg = rawText;
        }

        reject(errorMsg);
      };

      xhr.onerror = () => reject("Сетевая ошибка: сервер недоступен");

      if (method === "GET" || method === "DELETE") {
        xhr.send(null);
        return;
      }

      if (isFormData) {
        xhr.send(data);
      } else {
        xhr.send(data ? JSON.stringify(data) : null);
      }
    });
  }

  public static GetFileUrl(url?: string | null): string {
    if (!url) return "";

    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }

    return (process.env.REACT_APP_API_URL || "") + url;
  }
}
